var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-content"},[_c('Header'),_c('div',{staticClass:"body-content",class:_vm.isMobile ? 'body-content-active' : ''},[(_vm.$route.path == '/article')?_c('router-view'):_vm._e(),(_vm.$route.path != '/article')?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }